import { CmpCheck, loadScript, yieldToMainBackground } from "./utils";

export class MovieVideoPlayer {
	constructor() {
		this.show_ads = null;
		this.ready = false;
		this.jwp = document.querySelector('meta[name="video-setup"]')?.content;
	}

	async init() {
		return new Promise((resolve, reject) => {
			loadScript(
				"jwplayer",
				`https://content.jwplatform.com/libraries/${this.jwp}.js`,
			).then(() => {
				const checkCmp = new CmpCheck();
				checkCmp.checkConsent().then((response) => {
					this.show_ads = response;
					this.ready = true;
					resolve(this.ready);
				});
			});
		});
	}

	// Setup JW Player
	setupPlayer(id, video_id, no_ads, width, height, autostart = false) {
		//console.log(id);
		const config = {
			playlist: `https://cdn.jwplayer.com/v2/media/${video_id}`,
			autostart: autostart,
			skin: {
				name: "movie",
			},
		};

		if (width && height) {
			config.width = width;
			config.height = height;
		}
		if (no_ads === "true" || this.show_ads === false) {
			config.advertising = {};
		}
		return jwplayer(id).setup(config);
	}
}

// Display video player in a lightbox
function ajax_lightbox_player(element, video_container, movieJWP) {
	fetch(element.dataset.href, {
		headers: {
			"X-Requested-With": "XMLHttpRequest",
		},
	})
		.then((response) => response.text())
		.then((data) => {
			video_container.innerHTML = data;
			const video_player = video_container.querySelector("._player-video");
			const video_id = video_player.id;
			const jw_video_id = video_player.dataset.jw_video_id;
			const noads = video_player.dataset.noads;
			const autostart = video_player.dataset.autostart;
			const player = movieJWP.setupPlayer(
				video_id,
				jw_video_id,
				noads,
				autostart,
			);
			import("basiclightbox").then((basicLightbox) => {
				const lightbox = basicLightbox.create(video_container, {
					className: "basicLightbox--video-content",
					onShow: (instance) => {
						player.play();
					},
				});
				lightbox.show();
			});
		})
		.catch((error) => {
			console.warn(error);
		});
}

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	const movieJWP = new MovieVideoPlayer();
	movieJWP.init().then((is_ready) => {
		if (!is_ready) {
			return;
		}

		document.body.addEventListener("click", (event) => {
			// video con lightbox
			if (event.target?.classList.contains("_lightbox_video")) {
				event.preventDefault();
				yieldToMainBackground().then(() => {
					ajax_lightbox_player(
						event.target,
						event.target.nextElementSibling,
						movieJWP,
					);
				});
			}
		});

		// video in page
		for (const el of document.querySelectorAll("._player-video")) {
			yieldToMainBackground().then(() => {
				const video_id = el.id;
				const jw_video_id = el.dataset.jw_video_id;
				const noads = el.dataset.noads;
				const autostart = el.dataset.autostart;
				movieJWP.setupPlayer(video_id, jw_video_id, noads, autostart);
			});
		}
	});
});
